import { render } from "./PriceFilter.vue?vue&type=template&id=10197200&scoped=true&ts=true"
import script from "./PriceFilter.vue?vue&type=script&lang=ts"
export * from "./PriceFilter.vue?vue&type=script&lang=ts"

import "./PriceFilter.vue?vue&type=style&index=0&id=10197200&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10197200"]])

export default __exports__